import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserLanguage } from '../../utils/language';

const CartNotification = ({ isVisible, onClose, productName }) => {
  const [animationClass, setAnimationClass] = useState('cart-notification-hidden');
  const navigate = useNavigate();
  
  // Use the updated language utility that checks domain
  const language = getUserLanguage();
  
  // Translations
  const texts = {
    cs: {
      title: 'Přidáno do košíku',
      message: 'Produkt byl úspěšně přidán do košíku',
      continueShopping: 'Pokračovat v nákupu',
      goToCart: 'Přejít do košíku'
    },
    en: {
      title: 'Added to Cart',
      message: 'The product has been successfully added to your cart',
      continueShopping: 'Continue Shopping',
      goToCart: 'Go to Cart'
    }
  };
  
  const currentText = texts[language] || texts.en; // Fallback to English
  
  useEffect(() => {
    if (isVisible) {
      setAnimationClass('cart-notification-visible');
      
      // Auto-hide after 5 seconds if user doesn't interact
      const timer = setTimeout(() => {
        handleClose();
      }, 5000);
      
      return () => clearTimeout(timer);
    } else {
      setAnimationClass('cart-notification-hidden');
    }
  }, [isVisible]);
  
  const handleClose = () => {
    setAnimationClass('cart-notification-hidden');
    // Allow animation to complete before removing from DOM
    setTimeout(() => {
      onClose();
    }, 300);
  };
  
  const handleGoToCart = () => {
    navigate('/cart');
    handleClose();
  };
  
  if (!isVisible && animationClass === 'cart-notification-hidden') return null;
  
  return (
    <div className="cart-notification">
      <div className={`cart-notification-content ${animationClass}`}>
        <div className="cart-notification-inner">
          {/* Close button */}
          <button
            onClick={handleClose}
            className="cart-notification-close"
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          
          {/* Icon and title */}
          <div className="cart-notification-header">
            <div className="cart-notification-icon">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white cart-notification-checkmark" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h3 className="cart-notification-title">{currentText.title}</h3>
          </div>
          
          {/* Message */}
          <p className="cart-notification-message">
            {currentText.message}
          </p>
          
          {/* Product name if provided */}
          {productName && (
            <div className="cart-notification-product">
              <span className="cart-notification-product-name">
                "{productName}"
              </span>
            </div>
          )}
          
          {/* Actions */}
          <div className="cart-notification-actions">
            <button
              onClick={handleClose}
              className="cart-notification-btn btn-outline"
            >
              {currentText.continueShopping}
            </button>
            <button
              onClick={handleGoToCart}
              className="cart-notification-btn btn-drift cart-shake"
            >
              <i className="fas fa-shopping-cart text-xs mr-2"></i>
              {currentText.goToCart}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartNotification;